import { useState, useEffect } from 'react'
import { Container } from './Container'
import { ResponsiveImage } from './ResponsiveImage'

export function Header() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80)
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`inset-x-0 top-0 z-[9999] transition-all duration-300 ${
        scrolled ? 'fixed bg-[#1e232b]/90 backdrop-blur-md shadow-sm' : 'absolute'
      }`}
    >
      <Container>
        <div className="flex items-center justify-center py-4 sm:py-6 md:py-8">
          <a href="/" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1e232b] rounded">
            <ResponsiveImage name="ALL-White-logo-main-IMPACT" alt="Impact Real Estate Capital Partners" loading="eager" fallbackExt="png" className="h-8 sm:h-10 md:h-12 w-auto max-w-[180px] sm:max-w-none" width={180} height={48} />
          </a>
          <nav className="hidden">
            <ul className="flex gap-6 lg:gap-8 text-white/60 text-sm">
              <li className="hover:opacity-70">Home</li>
            </ul>
          </nav>
          <button
            type="button"
            onClick={() => setMobileNavOpen((o) => !o)}
            className="hidden md:hidden p-2 -mr-2 text-white/80 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1e232b]"
            aria-label={mobileNavOpen ? 'Close menu' : 'Open menu'}
          >
            {mobileNavOpen ? (
              <span className="text-2xl leading-none">×</span>
            ) : (
              <span className="flex flex-col gap-1.5">
                <span className="block w-6 h-0.5 bg-current rounded" />
                <span className="block w-6 h-0.5 bg-current rounded" />
                <span className="block w-6 h-0.5 bg-current rounded" />
              </span>
            )}
          </button>
        </div>
        {mobileNavOpen && (
          <div className="hidden md:hidden absolute left-0 right-0 top-full bg-[#1e232b]/95 backdrop-blur-sm border-b border-white/10">
            <Container>
              <ul className="py-4 text-white/80 text-sm space-y-1">
                <li><button type="button" onClick={() => setMobileNavOpen(false)} className="block w-full text-left py-2 hover:opacity-70">Home</button></li>
              </ul>
            </Container>
          </div>
        )}
      </Container>
    </header>
  )
}
